import { http } from '../jobs/api/http';

// ISOLATED planning sandbox — futureJob:* on the backend, never touches real jobs.
export const fetchFutureProducts = async () =>
  (await http.get('/api/redis/future-products')).data.products || [];

export const fetchFutureDashboard = async () =>
  (await http.get('/api/redis/future-products/dashboard')).data;

export const createFutureProducts = async payload =>
  (await http.post('/api/redis/future-products', payload)).data;

export const deleteFutureProduct = async id =>
  (await http.delete(`/api/redis/future-products/${id}`)).data;

// re-save an edited future product (same futureId) after the wizard preview/edit
export const updateFutureProduct = async (id, payload) =>
  (await http.put(`/api/redis/future-products/${id}`, payload)).data;

// Quick launch: promote the sandbox product to a REAL job using the SAME endpoint as
// Project Simulation (/orders-new-jobs) so it allocates to orders AND updates the
// dashboards / order-details / remaining-material — then delete the sandbox copy.
export const launchFutureProduct = async product => {
  const spec = product?._productSpec;
  const { mergedPhases = {}, groupByPhases = {} } = product?._launchConfig || {};
  const res = await http.post('/api/redis/orders-new-jobs', {
    standardData: Array.isArray(spec) ? spec : [spec],
    mergedPhases,
    groupByPhases
  });
  await http.delete(`/api/redis/future-products/${product.futureId}`);
  return res.data;
};
